import { Patology } from './Patology'

export interface PatologyDTO {
  id: string | undefined
  name: string
  cron: string
  priority: number | undefined
  min_steps: number
}

export function fromModel(d: Patology): PatologyDTO {
  return {
    id: d.id,
    name: d.name,
    cron: d.cron,
    priority: d.priority,
    min_steps: d.min_steps,
  }
}

export function toModel(d: PatologyDTO): Patology {
  return new Patology(d)
}
